import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './configure'
import { IWhatsNewComponent } from '@vacationtracker/shared/types/whats-new'

interface WhatsNewsState {
  whatsNewsIds: string[]
  // The last popup news the user closed; shown as a hint on the Vee launcher until dismissed.
  pendingHint: IWhatsNewComponent | null
}

const initialState: WhatsNewsState = {
  whatsNewsIds: [],
  pendingHint: null,
}

export const whatsNewsSlice = createSlice({
  name: 'whatsNews',
  initialState,
  reducers: {
    setWhatsNewId: (state, action: PayloadAction<string[]>) => {
      state.whatsNewsIds = action.payload
    },
    addWhatsNewId: (state, action: PayloadAction<string>) => {
      state.whatsNewsIds = [...state.whatsNewsIds, action.payload]
    },
    setPendingHint: (state, action: PayloadAction<IWhatsNewComponent | null>) => {
      state.pendingHint = action.payload
    },
  },
})

export const { setWhatsNewId, addWhatsNewId, setPendingHint } = whatsNewsSlice.actions

export const selectWhatsNewsSlice = (state: RootState) => state.whatsNewsSlice
export const selectPendingHint = (state: RootState) => state.whatsNewsSlice.pendingHint

export default whatsNewsSlice.reducer
